module.exports = __webpack_public_path__ + "img/bc243c2.jpg";